const actions = {
  GROUP_LISTING_BEGIN: 'GROUP_LISTING_BEGIN',
  GROUP_LISTING_SUCCESS: 'GROUP_LISTING_SUCCESS',
  GROUP_LISTING_ERR: 'GROUP_LISTING_ERR',

  PREVIEW_LISTING_BEGIN: 'PREVIEW_LISTING_BEGIN',
  PREVIEW_LISTING_SUCCESS: 'PREVIEW_LISTING_SUCCESS',
  PREVIEW_LISTING_ERR: 'PREVIEW_LISTING_ERR',

  UPDATE_LISTING_BEGIN: 'UPDATE_LISTING_BEGIN',
  UPDATE_LISTING_SUCCESS: 'UPDATE_LISTING_SUCCESS',
  UPDATE_LISTING_ERR: 'UPDATE_LISTING_ERR',

  groupListingBegin: () => {
    return {
      type: actions.GROUP_LISTING_BEGIN,
    };
  },
  groupListingSuccess: (data) => {
    return {
      type: actions.GROUP_LISTING_SUCCESS,
      data,
    };
  },
  groupListingErr: (err) => {
    return {
      type: actions.GROUP_LISTING_ERR,
      err,
    };
  },
  previewListingBegin: () => {
    return {
      type: actions.GROUP_LISTING_BEGIN,
    };
  },
  previewListingSuccess: (data) => {
    return {
      type: actions.GROUP_LISTING_SUCCESS,
      data,
    };
  },
  previewListingErr: (err) => {
    return {
      type: actions.GROUP_LISTING_ERR,
      err,
    };
  },
  updateListingBegin: () => {
    return {
      type: actions.UPDATE_LISTING_BEGIN,
    };
  },
  updateListingSuccess: (data) => {
    return {
      type: actions.UPDATE_LISTING_SUCCESS,
      data,
    };
  },
  updateListingErr: (err) => {
    return {
      type: actions.UPDATE_LISTING_ERR,
      err,
    };
  },
};
export default actions;
